// Action creators
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
import { ActionCreatorLoaderContext } from "../contexts/ActionCreatorLoaderContext";
// Utilities
import { useNullSafeContext } from "@ms/planner-generic-controls/lib/local/hooks/useNullSafeContext";
/**
 * Custom hook to resolve a set of action creators
 * @param actionCreatorKeys Array of action creators keys to resolve
 * @returns An array of action creators
 */ export function useActionCreators(actionCreatorKeys) {
    const actionCreatorLoader = useNullSafeContext(ActionCreatorLoaderContext);
    return actionCreatorKeys.map((key)=>actionCreatorLoader.load(key));
}
// Re-export ActionCreator enum for convenience
export { ActionCreator };
